import React from 'react';
import MainLayout from '../../layouts/MainLayout';

export const ExpertChats = () => {
  return <MainLayout>ExpertChats</MainLayout>;
};
